interface OEEGaugeProps {
    label: string;
    percentage: number | null | undefined;
}

function polarToCartesian(cx: number, cy: number, r: number, angleDeg: number) {
    const rad = (angleDeg * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
}

function arcPath(cx: number, cy: number, r: number, startDeg: number, endDeg: number): string {
    const s = polarToCartesian(cx, cy, r, startDeg);
    const e = polarToCartesian(cx, cy, r, endDeg);
    return `M ${s.x} ${s.y} A ${r} ${r} 0 0 1 ${e.x} ${e.y}`;
}

const FULL_ARC_START = 180;
const FULL_ARC_END = 360;
const GREEN = "#3CB371";
const RED = "#C64A4A";
const NO_DATA_BLUE = "#5B6B7F"; // Aspen-Birch rebrand: muted slate (was old-brand blue)
const TEXT_COLOR = "#2B2E3D";

export const OEEGauge = ({ label, percentage }: OEEGaugeProps) => {
    const cx = 100;
    const cy = 100;
    const r = 76;
    const sw = 26;
    const fontSize = 28;
    const labelSize = 18;
    const hasData = percentage != null;
    const p = hasData ? Math.min(1, Math.max(0, percentage / 100)) : 0;
    const breakAngle = FULL_ARC_START + p * 180;
    const fullArc = arcPath(cx, cy, r, FULL_ARC_START, FULL_ARC_END);
    const greenArc = hasData && p > 0 && p < 1 ? arcPath(cx, cy, r, FULL_ARC_START, breakAngle) : null;

    return (
        <div style={{ textAlign: "center" }}>
            <svg viewBox="0 0 200 114" style={{ width: "100%", display: "block", paddingBottom: "6px" }}>
                {/* Background arc (full semicircle) */}
                <path
                    d={fullArc}
                    fill="none"
                    stroke={!hasData ? NO_DATA_BLUE : p >= 1 ? GREEN : RED}
                    strokeWidth={sw}
                    strokeLinecap="round"
                />
                {/* Green filled portion */}
                {greenArc && <path d={greenArc} fill="none" stroke={GREEN} strokeWidth={sw} strokeLinecap="round" />}
                {hasData && p >= 1 && (
                    <path d={fullArc} fill="none" stroke={GREEN} strokeWidth={sw} strokeLinecap="round" />
                )}
                {/* Percentage label */}
                <text
                    x={cx}
                    y={cy - 14}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fill={TEXT_COLOR}
                    fontSize={fontSize}
                    fontWeight={500}
                    fontFamily="Source Sans 3, sans-serif"
                >
                    {hasData ? `${percentage}%` : "N/A"}
                </text>
            </svg>
            <div
                style={{
                    color: TEXT_COLOR,
                    fontSize: labelSize,
                    fontWeight: 600,
                    fontFamily: "Source Sans 3, sans-serif",
                    letterSpacing: "0.06em",
                    marginTop: 0,
                    paddingBottom: 4,
                }}
            >
                {label}
            </div>
        </div>
    );
};
